import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "RequestQuote"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 16.5V21H4.5V3H12V1.5H4.5C3.67157 1.5 3 2.17157 3 3V21C3 21.8284 3.67157 22.5 4.5 22.5H16.5C17.3284 22.5 18 21.8284 18 21V16.5H16.5ZM22.155 4.31999L19.68 1.84499C19.2134 1.38761 18.4666 1.38761 18 1.84499L7.5 12.345V16.5H11.6475L22.1475 5.99999C22.6049 5.53337 22.6049 4.7866 22.1475 4.31999H22.155ZM11.025 15H9V12.975L16.08 5.88748L18.1125 7.91998L11.025 15ZM17.1376 4.82999L19.1701 6.86249L20.8726 5.15999L18.8401 3.12749L17.1376 4.82999Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/RequestQuote.vue"]]);
